// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"89":"70347df8","158":"8b822c9a","210":"7a584e86","644":"0fa657b3","691":"a7efb688","813":"cff8b40b","873":"3e10ff3e","975":"8d7817d1"}[chunkId] + ".chunk.css";
};